import * as AC from './actionTypes';
import _ from 'lodash';

export const showSidebar = (showSidebar) => {
  return {
    type: AC.SHOW_BOOKING_SIDEBAR,
    showSidebar
  }
}

export const startFromBooking = (startFromBooking) => {
  return {
    type: AC.START_FROM_BOOKING,
    startFromBooking
  }
}

export const setDate = (dateType, dateValue, dateFormatted) => {
  let hash = {};
  hash[dateType] = {};
  hash[dateType]['value'] = dateValue;
  hash[dateType]['label'] = dateFormatted;
  return {
    type: AC.SET_BOOKING_DATE,
    dateObject: hash
  };
};

export const setChildrenNumber = (number) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_CHILDREN_NUMBER,
      number
    });
    dispatch(setBookingPrice());
    dispatch(resetKidsSafetyInBooking());
  }
}

export const setAdultsNumber = (number) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_ADULTS_NUMBER,
      number
    });
    dispatch(setBookingPrice());
  }
}

export const setStudentsNumber = (number) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_STUDENTS_NUMBER,
      number
    });
    dispatch(setBookingPrice());
  }
}

export const setDepartureFlight = (flight) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_DEPARTURE_FLIGHT,
      flight
    });
    dispatch(resetAddresses());
    dispatch(setBookingPrice());
  }
}

export const setReturnFlight = (flight) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_RETURN_FLIGHT,
      flight
    });
    dispatch(resetAddresses());
    dispatch(setBookingPrice());
  }
}

export const resetFlights = () => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.RESET_FLIGHTS
    });
    dispatch(setBookingPrice());
  }
}

export const resetAddresses = () => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.RESET_ADDRESSES
    });
  }
}

export const setAirport = (obj) => {
  let hash = {};
  hash[obj.airportType] = {};
  hash[obj.airportType]['id'] = obj.id;
  hash[obj.airportType]['label'] = obj.label;
  hash[obj.airportType]['isAirport'] = obj.isAirport;
  hash[obj.airportType]['code'] = obj.code;
  return {
    type: AC.SET_BOOKING_AIRPORT,
    airportObject: hash
  };
};

export const setKidsSafetyNumber = (name, number) => {
  var hash = {}
  hash[name] = number;
  return {
    type: AC.SET_KIDS_SAFETY_NUMBER,
    value: hash
  };
}

export const resetKidsSafetyInBooking = () => {
  return {
    type: AC.RESET_KIDS_SAFETY_IN_BOOKING,
  }

}

export const setReturnAddressPhrase = (phrase) => {
  return {
    type: AC.SET_RETURN_ADDRESS_PHRASE,
    phrase
  };
}

export const setReturnAddressObject = (object) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_RETURN_ADDRESS_OBJECT,
      object
    });
    dispatch(setBookingPrice());
  }
}

export const setDepartureAddressPhrase = (phrase) => {
  return {
    type: AC.SET_DEPARTURE_ADDRESS_PHRASE,
    phrase
  };
}

export const setDepartureAddressObject = (object) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_DEPARTURE_ADDRESS_OBJECT,
      object
    });
    dispatch(setBookingPrice());
  }
}

export const setDifferentReturnAddress = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_DIFFERENT_RETURN_ADDRESS,
      value
    });
    dispatch(setBookingPrice());
  }
}

export const setDepartureAddressPostcodeErrorLatLng = (error, postcode, street, coordsObj) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_DEPARTURE_ADDRESS_POSTCODE_ERROR_LAT_LNG,
      error,
      postcode,
      street,
      lat: coordsObj ? coordsObj["lat"] : null,
      lng: coordsObj ? coordsObj["lng"] : null,
    });
    dispatch(setBookingPrice());
  }
}

export const setReturnAddressPostcodeErrorLatLng = (error, postcode, street, coordsObj) => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_RETURN_ADDRESS_POSTCODE_ERROR_LAT_LNG,
      error,
      postcode,
      street,
      lat: coordsObj ? coordsObj["lat"] : null,
      lng: coordsObj ? coordsObj["lng"] : null,
    });
    dispatch(setBookingPrice());
  }
}

export const setBookingPrice = () => {
  return (dispatch, getState) => {
    dispatch({
      type: AC.SET_BOOKING_PRICE,
      priceList: getState().service.priceList
    });
  }
}

export const setBookingUserData = (key, value, error) => {
  var data = {};
  data[key] = value;
  if (error !== undefined) {
    var errorKey = "error" + _.upperFirst(key);
    data[errorKey] = error;
  }
  return {
    type: AC.SET_BOOKING_USER_DATA,
    data
  };
}

export const resetBooking = () => {
  return {
    type: AC.RESET_BOOKING
  }
}

export const setBookingCardId = (id) => {
  return {
    type: AC.SET_BOOKING_CARD_ID,
    id
  }
}

export const setInvoiceDataField = (key, name) => {
  var hash = {}
  hash[key] = name;
  return {
    type: AC.SET_INVOICE_FIELD_VALUE,
    hash
  }
}

export const toggleSendInvoice = () => {
  return {
    type: AC.TOGGLE_BOOKING_SEND_INVOICE,
  }
}

export const toggleCreateAccountInBooking = () => {
  return {
    type: AC.TOGGLE_CREATE_ACCOUNT_IN_BOOKING,
  }
}

export const setUserDataErrors = (errors, resetErrors) => {
  return {
    type: AC.SET_USER_DATA_ERRORS,
    errors,
    resetErrors
  }
}

export const startLoadingDataOnMap = () => {
  return {
    type: AC.START_LOADING_DATA_ON_MAP,
  }
}

export const stopLoadingDataOnMap = () => {
  return {
    type: AC.STOP_LOADING_DATA_ON_MAP,
  }
}

export const setUserNameOverride = (value) => {
  return {
    type: AC.SET_USER_NAME_OVERRIDE,
    value
  }
}

export const setUserPhoneOverride = (value) => {
  return {
    type: AC.SET_USER_PHONE_OVERRIDE,
    value
  }
}
